import { LOAD_RECEIPT, LOAD_RECEIPT_DETAIL } from "./actions";

const initialState = {
  lists: [],
  detailLists: [],
  total: 1,
  detailTotal: 1,
  loading: false,
  detailLoading: false,
  draw: -1
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_RECEIPT.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading
      };
    case LOAD_RECEIPT.SUCCESS:
      const { page } = action.payload;
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1;
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10;
      }
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };
    case LOAD_RECEIPT_DETAIL.REQUEST:
      return {
        ...state,
        detailLoading:
          typeof action.payload.data.intervalLoading === "undefined"
      };
    case LOAD_RECEIPT_DETAIL.SUCCESS:
      return {
        ...state,
        detailLists: action.payload.lists,
        detailTotal: action.payload.lists.length,
        detailLoading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };
    default:
      return state;
  }
};
